<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-Page-Break">Chapter One</p>
<p class="center" style="margin-top:1em; margin-bottom:1em;"><img alt="" src="image/Image3.jpg"/></p>
<p class="ORIM-Chapter-Opener-Paragraph"><span class="ORIM-Chapter-First-Words">“WHAT DOES ‘EXTINCT’ MEAN?” ASKED</span> Mr. Watkins.</p>
<p class="ORIM-Body-Text">“Something that isn’t there any more,” said Polly Turf.</p>
<p class="ORIM-Body-Text">“Like what? Give an example. You, Fred.”</p>
<p class="ORIM-Body-Text">“A puffin,” said Fred, after thought, chewing his ballpoint.</p>
<p class="ORIM-Body-Text">“Dope!” cried Polly. “There’s lots of puffins.”</p>
<p class="ORIM-Body-Text">“A dodo?”</p>
<p class="center" style="margin-top:1em; margin-bottom:1em;"><img alt="" src="image/Image4.jpg"/></p>
<p class="ORIM-Body-Text">“Good, Annie! Stewart, can you name something else that’s extinct?”</p>
<p class="ORIM-Body-Text">“A whale?” </p>
<p class="ORIM-Body-Text">“Not yet, we <em class="italic">hope.</em> Amanda?”</p>
<p class="center" style="margin-top:1em; margin-bottom:1em;"><img alt="" src="image/Image5.jpg"/></p>
<p class="ORIM-Body-Text">“A bear?”</p>
<p class="ORIM-Body-Text">“Not quite. Try again.”</p>
<p class="ORIM-Body-Text">“A dinosaur.”</p>
<p class="ORIM-Body-Text">“Good. You—Jon Witnes—bring your mind back from outside the window, if you please, and tell us something that’s extinct.”</p>
<p class="ORIM-Body-Text">A buzz of laughter ran round the classroom. Jon Witnes had his chin propped on his fist, and his gaze lay far away, through the open window, on the slope of moorland and the crags at the head of the valley.</p>
<p class="center" style="margin-top:1em; margin-bottom:1em;"><img alt="" src="image/Image6.jpg"/></p>
<p class="ORIM-Body-Text">“<em class="italic">Witless Witness</em>!”<em class="italic"></em> somebody whispered.</p>
<p class="center" style="margin-top:1em; margin-bottom:1em;"><img alt="" src="image/Image7.jpg"/></p>
<p class="ORIM-Body-Text">But it seemed that Jon did have his wits about him after all.</p>
<p class="ORIM-Body-Text">“Something that’s extinct—um, yes,” he said. “A Moropus.”</p>
<p class="ORIM-Body-Text">“A what-o-puss?” said Fred. The others took it up.</p>
<p class="ORIM-Body-Text">“A purrapuss—a platypus—a were-a-puss!”</p>
<p class="ORIM-Body-Text">“Quiet, class! Yes, Jon—that was a good answer.”</p>
<p class="ORIM-Body-Text">“Sir, what’s a morrow-puss?” somebody called.</p>
<p class="center" style="margin-top:1em; margin-bottom:1em;"><img alt="" src="image/Image8.jpg"/></p>
<p class="ORIM-Body-Text">“It’s a prehistoric horse,” Jon said calmly. “It was big and furry and it had claws on its feet instead of hoofs.”</p>
<p class="ORIM-Body-Text">“Just like Whiskers! Just like Jon’s old fat pony.”</p>
<p class="ORIM-Body-Text">“All right, that’ll do,” said Mr. Watkins. “Julie, think of something else that could be extinct, besides animals.”</p>
<p class="ORIM-Body-Text">“Plants? Us?”</p>
<p class="center" style="margin-top:1em; margin-bottom:1em;"><img alt="" src="image/Image9.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled22.vue?142a5d18